// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__JWazv","description":"MealItem_description__Pd2gE","price":"MealItem_price__fbkTI"};